import Typography from "@/components/Typography";
import { cx } from "@/utils";

import styles from "./HelperText.module.css";

type HelperTextProps = {
  content?: React.ReactNode;
  className?: string;
  error?: boolean;
};

const HelperText: React.FunctionComponent<HelperTextProps> = ({
  content,
  error = false,
  className,
  ...rest
}) => {
  return (
    <Typography
      variant="caption"
      className={cx(styles.root, { [styles.error]: error }, className)}
      {...rest}
    >
      {content}
    </Typography>
  );
};

export default HelperText;
